export const mask = (value: string, pattern: string) => {
  let i = 0;
  const v = value.toString();

  return pattern.replace(/#/g, () => {
    const char = v[i];
    i += 1;

    return char;
  });
};
